module.exports = __webpack_public_path__ + "media/components/assets/icons/eye_open-595b6287e9bb77482261d0a0a34b822d.svg";